import React, { useRef } from 'react';
import { ButtonGroup } from 'react-bootstrap';
import { Link } from '../../../../../Router';
import { useHistory } from 'react-router-dom';
import { routes } from '../../../routes';
import { createTimeSheetPageQueryParams } from '.';
import Flatpickr from 'react-flatpickr';
import { toFlatpickrLocale } from '../../../../../components/form/flatpickrUtils';
import { useCurrentLocale } from '../../../../../context/I18n';
import { useTranslation } from 'react-i18next';
import { parseDate, toISODateOnly } from '../../../../../utils/dateUtils';
import { Instance as FlatpickrInstance } from 'flatpickr/dist/types/instance';

type FlatpickrRef = InstanceType<typeof Flatpickr> & {
  flatpickr: FlatpickrInstance;
};
type Props = {
  startDate: string;
  title: string;
  previousTimeSheetStartDay: string;
  nextTimeSheetStartDay: string;
};

const Nav: React.FC<Props> = ({
  startDate,
  previousTimeSheetStartDay,
  nextTimeSheetStartDay,
  title,
}) => {
  const history = useHistory();
  const locale = toFlatpickrLocale(useCurrentLocale());
  const { t } = useTranslation();
  const flatpickrRef = useRef<FlatpickrRef | null>(null);

  const handleDatePickerClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (flatpickrRef.current?.flatpickr) {
      flatpickrRef.current.flatpickr.open();
    }
  };

  const handleDateChange = (dates: Date[]) => {
    if (dates[0]) {
      const selectedDate = toISODateOnly(dates[0]);
      const url = routes.timeTracking.route
        .withQueryParams(
          createTimeSheetPageQueryParams({
            startDate: selectedDate,
          }),
        )
        .create({});
      history.push(url);
    }
  };

  return (
    <div className="text-end">
      <ButtonGroup size="sm" className="bg-gray rounded p-1">
        <Link
          to={routes.timeTracking.route.withQueryParams(
            createTimeSheetPageQueryParams({
              startDate: previousTimeSheetStartDay,
            }),
          )}
          className="btn btn-gray">
          ←
        </Link>
        <button
          type="button"
          className="btn btn-sm btn-white rounded"
          onClick={handleDatePickerClick}>
          {title}
        </button>
        <Flatpickr
          ref={flatpickrRef}
          className="datepicker-input-hidden"
          options={{
            locale,
            dateFormat: t('flatpickr.dateFormat'),
            enableTime: false,
            clickOpens: false,
          }}
          value={parseDate(startDate)}
          onChange={handleDateChange}
        />
        <Link
          to={routes.timeTracking.route.withQueryParams(
            createTimeSheetPageQueryParams({
              startDate: nextTimeSheetStartDay,
            }),
          )}
          className="btn btn-gray">
          →
        </Link>
      </ButtonGroup>
    </div>
  );
};

export default Nav;
